function Contact() {
  return <h1>Contact me on this page.</h1>
}

export default Contact
